document.addEventListener("change", function(e){

  const select = e.target.closest("select[name='locale_code']");
  if(!select) return;

  const lang = select.value;

  const map = {
    ro: "RO",
    de: "DE",
    fr: "FR",
    en: "EU"
  };

  const country = map[lang];
  if(!country) return;

  fetch("/localization",{
    method:"POST",
    headers:{
      "Content-Type":"application/x-www-form-urlencoded"
    },
    body:"country_code="+country+"&locale_code="+lang
  }).then(()=>location.reload());

});